import { Box, Button, CardMedia, Grid, IconButton, Theme, Tooltip, Typography, useTheme } from '@mui/material';
import React from 'react';
import { Item, ItemDetails } from './index';
import { Applicant, ApplicationProps } from '../../redux-store/types/api-types';
import { SubHeading } from '../investors/components';
import { ENABLE_KRA_DOCUMENT_FETCH, USER_ROLES } from '../../utils/constant';
import { checkKraBasedOnStatus, formatFileSize } from '../../utils/utilityFunctions';
import { useSelector } from 'react-redux';
import { RootStateType } from '../../redux-store/reducers';
import { DownloadIcon } from '../../assets/SvgIcons';
import dayjs from '../../utils/dayjs';

export const getFieldTitle: { [key: string]: string } = {
  addressProof: 'Address Proof',
  identityProof: 'Identity Proof',
  bankAccountProof: 'Bank Account Proof',
  poaNotarized: 'Poa Notarized Document',
  investorsConsent: 'Investors Consent Document',
  fatca: 'Fatca Document',
  form_10ff_trc: 'Form 10F/TRC',
  additional: 'Additional Documents',
  investorPhotograph: 'Investor Photograph',
  investorSignature: 'Investor Signature',
  compliance_document: 'Compliance Document',
  pioCard: 'PIO CARD',
  overseaseAddressProof: 'Overseas Address Proof',
  passportCopy: 'Passport Copy (1st and last page) and Visa Copy',
  nomineeIdProof: 'Nominee PAN',
  guardianIdProof: 'Guardian ID Proof',
  aadhaar_card: 'Aadhaar Card',
  pan_card: 'PAN Card',
  correspondenceAddress: 'Correspondence Address Proof',
  physical_signed_document: 'Physical Signed Document',
  nominee_opt_out: 'Nominee Opt out Declaration'
};

export default function DocumentDetails({
  application,
}: {
  application: ApplicationProps;
}): JSX.Element {
  const { applicants, nominees } = application;
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const theme = useTheme();
  return (
    <>
      <Box
        sx={(theme: Theme) => ({
          // bgcolor: 'white',
          bgcolor: theme.palette.customColors.infoCard,
          // boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
          borderRadius: '10px',
          border: `1px solid ${theme.palette.grey[100]}`,
          boxShadow: `0px 4px 10px 0px ${theme.palette.common.black}1A`,
          padding: '25px',
        })}
        mt={5}
      >
        {/* <Box sx={{ p: 2 }}> */}
        <Grid
          container
        // sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}
        // sx={{ py: "25px", px: { xs: "15px", sm: "25 px" } }}
        >
          <Typography variant='body_700' sx={{ color: 'primary.500' }}>
            {/* Document Details */}
            Upload Documents
          </Typography>
          {(applicants ?? []).map((applicant, index: number) => {
            const title = [
              'First Applicant Details',
              'Second Applicant Details',
              'Third Applicant Details',
            ][index];
            return (
              <React.Fragment key={applicant.id}>
                {applicant.documents && applicant.documents.length !== 0 && (
                  <Grid item xs={12}>
                    <SubHeading
                    // sx={{ letterSpacing: 0.5 + 'px' }}
                    >
                      {title}
                    </SubHeading>
                  </Grid>
                )}
                {ENABLE_KRA_DOCUMENT_FETCH &&
                  USER_ROLES.INVESTOR !== role &&
                  applicant.documents &&
                  applicant.documents.length === 0 &&
                  checkKraBasedOnStatus(application.status) && (
                    <Grid item xs={12}>
                      <SubHeading
                      // sx={{ letterSpacing: 0.5 + 'px' }}
                      >
                        {title}
                      </SubHeading>
                    </Grid>
                  )}
                {ENABLE_KRA_DOCUMENT_FETCH && USER_ROLES.INVESTOR !== role
                  ? applicant.documents &&
                  applicant.documents.length === 0 &&
                  index === 0 &&
                  !applicant.kraDocument &&
                  !checkKraBasedOnStatus(application.status) && (
                    <Grid
                      item
                      xs={12}
                      // sm={12}
                      sx={{
                        // fontSize: 18,
                        // fontWeight: 600,
                        // color: 'common.black',
                        textAlign: 'center',
                        my: 3,
                      }}>
                      {/* No Documents */}
                      <Typography variant='body_600' sx={{ color: 'text.primary' }}>
                        No Documents
                      </Typography>
                    </Grid>
                  )
                  : applicant.documents &&
                  applicant.documents.length === 0 &&
                  index === 0 && (
                    <Grid
                      item
                      xs={12}
                      // sm={12}
                      sx={{
                        // fontSize: 18,
                        // fontWeight: 600,
                        // color: 'common.black',
                        textAlign: 'center',
                        my: 3,
                      }}>
                      {/* No Documents */}
                      <Typography variant='body_600' sx={{ color: 'text.primary' }}>
                        No Documents
                      </Typography>
                    </Grid>
                  )}
                <Grid
                  item
                  container
                  pt={applicant.documents && applicant.documents.length && 2}
                  pb={applicant.documents && applicant.documents.length && 5}
                  rowSpacing={4}
                  columnSpacing={5}
                // sx={{ pl: { xs: 0, sm: 7, md: 10, lg: 13 } }}
                >
                  {applicant.documents &&
                    applicant.documents.map((document, index: number) => {
                      return (
                        <React.Fragment key={document.id}>
                          <Grid
                            item
                            xs={12}
                            sm={6}
                            md={document.file ? 6 : 12}
                            sx={{ mt: index !== 0 ? 2 : 0 }}
                          >
                            <Item sx={(theme: Theme) => ({

                              ...theme.typography.body_500,
                              letterSpacing: '0.02px',
                              color: theme.palette.text.primary
                            })}>{getFieldTitle[document.documentType]}</Item>
                            {document.documentType === 'investorSignature' && (
                              <Typography
                                sx={{
                                  fontWeight: 400,
                                  fontSize: 14,
                                  color: 'text.secondary'
                                }}>
                                (This signature copy is used as a verification process for future
                                redemptions and transfer requests)
                              </Typography>
                            )}

                            <ItemDetails sx={(theme: Theme) => ({
                              ...theme.typography.body_500,
                              color: theme.palette.text.secondary,
                              mt: 1
                            })}>
                              {document.documentName?.toLowerCase() ===
                                getFieldTitle[document.documentType]?.toLowerCase()
                                ? ""
                                : document.documentName}
                            </ItemDetails>
                            {document?.expiryDate && (
                              <ItemDetails sx={(theme: Theme) => ({
                                ...theme.typography.body_400,
                                color: theme.palette.text.secondary,
                                mt: 1
                              })}>
                                <Typography component="span" sx={{ fontWeight: "600" }}>Expiry Date:</Typography> {document?.expiryDate ? dayjs(document?.expiryDate).format('DD/MM/YYYY') : ""}
                              </ItemDetails>
                            )}

                          </Grid>
                          {
                            document.file && (
                              <Grid item xs={12} sm={6}>
                                {/* <Box
                                sx={{
                                  display: 'flex',
                                  mt: index !== 0 ? { sm: 8, xs: 2 } : 2,
                                  flexDirection: { sm: 'column', xs: 'row', md: 'row' },
                                }}>
                                <Button
                                  variant="contained"
                                  sx={{
                                    color: 'common.white',
                                    // minWidth: { xs: '90%', sm: '100%', md: '70%' },
                                    minWidth: '70%',
                                    // mt: index !== 0 ? { sm: 8, xs: 2 } : 2,
                                    fontWeight: 600,
                                    lineHeight: 1.5,
                                  }}
                                  onClick={() => window.open(document.file?.viewUrl)}>
                                  View
                                </Button>
                                <Tooltip title={'Download'}>
                                  <IconButton
                                    sx={{
                                      // p: 0,
                                      // pl: 1.5,
                                      ':hover': {
                                        bgcolor: '#F4FCFC',
                                      },
                                      cursor: 'pointer',
                                      pointerEvents: 'all',
                                      // mt: index !== 0 ? { sm: 8, xs: 2 } : 2,
                                    }}
                                    onClick={() => window.open(document.file?.url)}>
                                    <CardMedia
                                      component="img"
                                      src={'/images/download-icon.png'}
                                      alt="Download"
                                      sx={{ width: '25px' }}
                                    />
                                  </IconButton>
                                </Tooltip>
                              </Box> */}
                                <Grid
                                  container
                                  sx={(theme: Theme) => ({
                                    borderRadius: "10px",
                                    backgroundColor: `${theme.palette.common.white}0D`,
                                    border: `0.5px solid ${theme.palette.text.secondary}80`,
                                    padding: "15px",
                                    alignItems: "stretch"
                                  })}
                                  columnSpacing={2}
                                >
                                  <Grid
                                    xs={2}
                                    item
                                    sx={(theme: Theme) => ({
                                      borderRadius: "10px",
                                      // backgroundColor: theme.palette.grey[50],
                                      // width: '60px',
                                      // height: '60px'

                                    })}
                                  >
                                    <CardMedia
                                      component="img"
                                      src={`${document?.file?.thumbnailUrl}`}
                                      alt="Thumbnail"
                                      sx={{
                                        width: "100%",
                                        objectFit: "contain",
                                        // md: {
                                        //   width: '60px',
                                        //   height: '60px'
                                        // },

                                        // sm: {
                                        //   width: '40px',
                                        //   height: '40px'
                                        // }
                                      }}

                                    />
                                  </Grid>
                                  <Grid
                                    item
                                    container
                                    xs={8}
                                    rowSpacing={0.2}
                                  >
                                    <Grid item xs={12}>
                                      <Typography variant='subtitle_500'>{document?.file?.name ?? ""}</Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                      <Typography variant='overline_400' sx={{ color: "text.secondary" }}>{formatFileSize(document?.file?.size)}
                                      </Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                      <Button
                                        component={'span'}
                                        // variant='overline_600'
                                        sx={{ color: "primary.500", cursor: "pointer", ...theme.typography.overline_600 }}
                                        onClick={() => window.open(document.file?.viewUrl)}
                                        aria-label='Click to view Document'
                                        role='link'
                                      >
                                        Click to view
                                      </Button>
                                    </Grid>
                                  </Grid>
                                  <Grid
                                    item
                                    container
                                    justifyContent='flex-end'
                                    alignItems="flex-start"
                                    xs={2}
                                  >
                                    <IconButton
                                      sx={{
                                        cursor: "pointer"
                                      }}
                                      aria-label='Download document'
                                      onClick={() => window.open(document.file?.url)}>
                                      <DownloadIcon />
                                    </IconButton>
                                  </Grid>
                                </Grid>
                              </Grid>
                            )
                          }
                        </React.Fragment>
                      );
                    })}
                  {ENABLE_KRA_DOCUMENT_FETCH &&
                    USER_ROLES.INVESTOR !== role &&
                    checkKraBasedOnStatus(application.status) &&
                    (applicant.kraDocument && applicant.kraDocument.length > 0 ? (
                      <>
                        {applicant.kraDocument.map((document, index: number) => {
                          return (
                            <React.Fragment key={document.id}>
                              <Grid
                                item
                                xs={12}
                                sm={6}
                                md={document ? 6 : 12}
                                sx={{
                                  mt:
                                    applicant.documents && applicant.documents.length === 0
                                      ? 0
                                      : 6,
                                }}>
                                <Item>{'KRA Documents'}</Item>
                                <ItemDetails>{document.name}</ItemDetails>
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <Button
                                  variant="contained"
                                  sx={{
                                    color: 'common.white',
                                    minWidth: { xs: '90%', sm: '100%', md: '70%' },
                                    mt:
                                      applicant.documents && applicant.documents.length === 0
                                        ? 2
                                        : { sm: 8, xs: 2 },
                                    fontWeight: 600,
                                    lineHeight: 1.5,
                                  }}
                                  onClick={() => window.open(document.url)}>
                                  Download
                                </Button>
                              </Grid>
                            </React.Fragment>
                          );
                        })}
                      </>
                    ) : (
                      <>
                        <React.Fragment>
                          <Grid
                            item
                            xs={12}
                            sm={6}
                            md={document ? 6 : 12}
                            sx={{
                              mt: applicant.documents && applicant.documents.length === 0 ? 0 : 6,
                            }}>
                            <Item>{'KRA Documents'}</Item>
                            <ItemDetails>{'KRA Documents in Progress'}</ItemDetails>
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <Button
                              variant="contained"
                              sx={{
                                color: 'common.white',
                                minWidth: { xs: '90%', sm: '100%', md: '70%' },
                                mt:
                                  applicant.documents && applicant.documents.length === 0
                                    ? 2
                                    : { sm: 8, xs: 2 },
                                fontWeight: 600,
                                lineHeight: 1.5,
                              }}
                              disabled={true}
                            // onClick={() => window.open(document.url)}
                            >
                              Download
                            </Button>
                          </Grid>
                        </React.Fragment>
                      </>
                    ))}
                </Grid>
              </React.Fragment>
            );
          })}
          {(nominees ?? []).length !== 0 &&
            nominees.map((nominee, index: number) => {
              const { nomineedocuments = [] } = nominee;
              const title = [
                'First Nominee Details',
                'Second Nominee Details',
                'Third Nominee Details',
              ][index];
              return (
                <React.Fragment key={nominee.id}>
                  {nomineedocuments && nomineedocuments.length !== 0 && (
                    <SubHeading sx={{ letterSpacing: 0.5 + 'px' }}>{title}</SubHeading>
                  )}
                  <Grid
                    container
                    pt={nomineedocuments && nomineedocuments.length && 2}
                    pb={nomineedocuments && nomineedocuments.length && 5}
                    columnSpacing={13}
                    sx={{ pl: { xs: 0, sm: 7, md: 10, lg: 13 } }}>
                    {nomineedocuments &&
                      nomineedocuments.map((document, index: number) => {
                        return (
                          <React.Fragment key={document.id}>
                            <Grid
                              item
                              xs={12}
                              sm={6}
                              md={document.file ? 6 : 12}
                              sx={{ mt: index !== 0 ? 6 : 0 }}>
                              <Item>{getFieldTitle[document.documentType]}</Item>
                              <ItemDetails>
                                {document.documentName?.toLowerCase() ===
                                  getFieldTitle[document.documentType]?.toLowerCase()
                                  ? document.file?.name
                                  : document.documentName}
                              </ItemDetails>
                            </Grid>
                            {document.file && (
                              <Grid item xs={12} sm={6}>
                                <Box
                                  sx={{
                                    display: 'flex',
                                    mt: index !== 0 ? { sm: 8, xs: 2 } : 2,
                                    flexDirection: { sm: 'column', xs: 'row', md: 'row' },
                                  }}>
                                  <Button
                                    variant="contained"
                                    sx={{
                                      color: 'common.white',
                                      // minWidth: { xs: '90%', sm: '100%', md: '70%' },
                                      minWidth: '70%',
                                      // mt: index !== 0 ? { sm: 8, xs: 2 } : 2,
                                      fontWeight: 600,
                                      lineHeight: 1.5,
                                    }}
                                    onClick={() => window.open(document.file?.viewUrl)}>
                                    View
                                  </Button>
                                  <Tooltip title={'Download'}>
                                    <IconButton
                                      sx={{
                                        // p: 0,
                                        // pl: 1.5,
                                        ':hover': {
                                          bgcolor: '#F4FCFC',
                                        },
                                        cursor: 'pointer',
                                        pointerEvents: 'all',
                                        // mt: index !== 0 ? { sm: 8, xs: 2 } : 2,
                                      }}
                                      onClick={() => window.open(document.file?.url)}>
                                      <CardMedia
                                        component="img"
                                        src={'/images/download-icon.png'}
                                        alt="Download"
                                        sx={{ width: '25px' }}
                                      />
                                    </IconButton>
                                  </Tooltip>
                                </Box>
                              </Grid>
                            )}
                          </React.Fragment>
                        );
                      })}
                  </Grid>
                </React.Fragment>
              );
            })}
        </Grid >
      </Box >
      {/* </Box> */}
    </>
  );
}
